export enum DOCUMENT_STATUS {
	NotSigned = 0,
	NotSignedLate = 1,
	Signed = 2,
	Validated = 3,
	Integrated = 4,
}
